import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  viewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { AccountFormWrapperComponent } from '../components/account-form-wrapper/account-form-wrapper.component';
import {
  ACCOUNT_FORM_CONFIG,
  AccountFormConfig,
  AccountFormMode,
} from '../e-invoice-account.config';

const TITLE_KEYS: Record<AccountFormMode, string> = {
  add: 'e_invoice.account.form.title_add',
  edit: 'e_invoice.account.form.title_edit',
  view: 'e_invoice.account.form.title_view',
};

@Component({
  selector: 'app-account-form',
  imports: [AccountFormWrapperComponent],
  templateUrl: './account-form.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountFormComponent implements CanComponentDeactivate {
  private readonly route = inject(ActivatedRoute);

  private readonly formWrapper =
    viewChild<AccountFormWrapperComponent>('formWrapper');

  readonly mode: AccountFormMode =
    this.route.snapshot.data['mode'] ?? 'add';

  readonly config = computed<AccountFormConfig>(() => ({
    ...ACCOUNT_FORM_CONFIG,
    title: TITLE_KEYS[this.mode],
  }));

  canDeactivate(): boolean {
    return this.formWrapper()?.canDeactivate() ?? true;
  }
}
